import { type FC } from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as styles from "./styles.css";

type Props = {
  isShadow: boolean;
};

export const Loading: FC<Props> = ({ isShadow }) => {
  return (
    <div
      className={styles.cassette}
      style={assignInlineVars({
        [styles.boxShadow]: isShadow ? "0px 2px 4px 0px rgba(0, 0, 0, 0.10)" : "none",
      })}
      aria-label="読み込み中"
    >
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner} />
      </div>
    </div>
  );
};
